import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../../pagetitle/PageTitle'
import AltinSponsorCard from '../../../sponsorcard/AltinSponsorCard'

export default function AltinSponsorlar()
{
    const title = "OKAF Altın Sponsorlar- Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın altın sponsorlarına ulaşmak için tıklayınız!";
    return (
        <>
            <Helmet>
                    <title>{title}</title>
                    <meta name="description" content={description} />
                </Helmet>
            <PageTitle name="Altın Sponsorlar"></PageTitle>
            <AltinSponsorCard />
        </>
    )
}
